import { useState } from "react";
import Navbar from "../components/Navbar";
import "../assets/css/calendar.css";

// Schools list
const schools = [
  { name: "Department of Nursing Sciences", key: "nursing" },
  { name: "Anaesthetic Technicians", key: "anaesthetic" },
  { name: "School of Community Health", key: "community" },
  { name: "Federal School of Biomedical Engineering", key: "biomedical" },
  { name: "School of Health Information Management", key: "healthinfo" },
  { name: "School of Medical and Psychiatry Social Work", key: "socialwork" },
  { name: "School Of Midwifery", key: "midwifery" },
  { name: "School Of Post Basic Nursing", key: "postbasic" },
];

// Dummy calendar events for schools with specific dates and times
const calendarEvents = [
  {
    school: "Department of Nursing Sciences",
   date: "Saturday, 10th October 2026",
    time: "8:00 AM",
    venue: "LUTH Human Resources Building Auditorium, LUTH Campus, Idi-Araba, Lagos",
  },
  {
    school: "Anaesthetic Technicians",
      date: "Friday, 9th October 2026",
    time: "8:00 AM",
    venue: "LUTH Human Resources Building Auditorium, LUTH Campus, Idi-Araba, Lagos",
  },
  {
    school: "School of Community Health",
    date: "Thursday, 24th September 2026",
    time: "8:00 AM",
    venue: "LUTH Human Resources Building Auditorium, LUTH Campus, Idi-Araba, Lagos",
  },
  {
    school: "Federal School of Biomedical Engineering (ND Programme Only)",
    date: "Friday, 9th October 2026",
    time: "8:00 AM",
    venue: "LUTH Human Resources Building Auditorium, LUTH Campus, Idi-Araba, Lagos",
  },
  {
    school: "School of Health Information Management (ND Programme Only)",
    date: "Friday, 25th September 2026",
    time: "8:00 AM",
    venue: "LUTH Human Resources Building Auditorium, LUTH Campus, Idi-Araba, Lagos",
  },
  {
    school: "School of Medical and Psychiatry Social Work",
    date: "Friday, 9th October 2026",
    time: "8:00AM",
    venue: "LUTH Human Resources Building Auditorium, LUTH Campus, Idi-Araba, Lagos",
  },
  {
    school: "School Of Midwifery",
    date: "Not yet scheduled",
    time: "Not yet scheduled",
    venue: "Not yet scheduled",
  },

  {
    school: "School Of Post Basic Nursing",
    date: "Saturday, 26th September 2026",
    time: "8:00 AM",
    venue: "LUTH Human Resources Building Auditorium, LUTH Campus, Idi-Araba, Lagos",
  },
];

const SchoolUTMECalendar = () => {
  const [filter, setFilter] = useState(null);
  const filteredEvents = filter
    ? calendarEvents.filter((e) => e.school === filter)
    : calendarEvents;

  return (
    <>
      <Navbar />
      <main className="calendar-wrapper">
        <h1 className="calendar-title">Post-UTME Calendar by School</h1>
        <section className="filter-buttons">
          <button
            className={!filter ? "active" : ""}
            onClick={() => setFilter(null)}
          >
            All Schools
          </button>
          {schools.map((s) => (
            <button
              style={{ color: "#333" }}
              key={s.key}
              className={filter === s.name ? "active" : ""}
              onClick={() => setFilter(s.name)}
            >
              {s.name}
            </button>
          ))}
        </section>
        <section className="calendar-container">
          {filteredEvents.length > 0 ? (
            filteredEvents.map((event, idx) => (
              <div key={idx} className="calendar-card">
                <h3>{event.school}</h3>
                <p>
                  <strong>Date:</strong> {event.date}
                </p>
                <p>
                  <strong>Time:</strong> {event.time}
                </p>
                <p>
                  <strong>Venue:</strong> {event.venue}
                </p>
              </div>
            ))
          ) : (
            <p className="no-events">No events for selected school.</p>
          )}
        </section>
      </main>
    </>
  );
};

export default SchoolUTMECalendar;
